import { put, select, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from 'Domain/App/Ducks/Table.duck';
import { getCredentialRequests } from '../Services/CredentialService';

export const actionTypes = {
  RequestData: '[CredentialRequests] Request',
  FulfilledTable: '[CredentialRequests] Fulfilled',
  SearchTable: '[CredentialRequests] Search',
  ChangePage: '[CredentialRequests] change page',
  SetPageSize: '[CredentialRequests] set page size',
  SortTable: '[CredentialRequests] Sort',
  ApplyFilter: '[CredentialRequests] Apply filter',
  RemoveFilter: '[CredentialRequests] Remove filter',
};

const initialState = {
  ...tableInitialState,
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestEmailsSaga() {
    const currentState = yield select(state => {
      return state.CredentialRequestsReducer;
    });

    const response = yield getCredentialRequests(
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });
}
